/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ApiKeyOperation = core.serialization.object({
    path: core.serialization.string(),
    method: core.serialization.string(),
});
